import React from "react";
import { useNavigate } from "react-router-dom";
import { getContentGroupsViewPath } from "../organizeUtil";

import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

const NotFound = () => {
  const navigate = useNavigate();
  const handleClick = () => navigate(getContentGroupsViewPath());
  return (
    <Grid
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
      spacing={2}
      style={{ height: "100%" }}
    >
      <Grid item>
        <Typography variant="h2" style={{ fontSize: "4rem" }}>
          404
        </Typography>
      </Grid>
      <Grid item>
        <Typography>It looks like this item doesn't exist.</Typography>
      </Grid>
      <Grid item>
        <Button
          onClick={handleClick}
          color="primary"
          variant="contained"
          style={{ width: "auto" }}
          aria-label="Go to Organize home screen"
        >
          Start Organizing
        </Button>
      </Grid>
    </Grid>
  );
};

export default NotFound;
